<script setup lang="ts">
import { computed } from 'vue'
import { useStudentScreen } from './useStudentScreen'
import type { Student2Context } from '@/types/student2'

const props = defineProps<{ context: Student2Context }>()
const { isMobileLocal } = useStudentScreen()

const teacherName = computed(() => {
  const teacher = props.context.student.teachers[0]
  return [teacher.first_name, teacher.last_name].join(' ')
})
</script>

<template>
  <v-menu-base v-if="context.student.teachers.length" pos-horizontal="right" no-mobile-modal>
    <template #activator="{ onclick }">
      <v-button mode="primary outlined small" @click="onclick">
        <span v-if="!isMobileLocal" class="mr-half">С учителем</span>
        <v-icon>mdi-school</v-icon>
        <img height="24" :src="context.student.teachers[0].profile_image" class="ml-1 student-teacher-menu__avatar" />
      </v-button>
    </template>

    <div class="student-teacher-menu pa-2">
      <img height="64" :src="context.student.teachers[0].profile_image" class="student-teacher-menu__avatar" />

      <div class="d-flex flex-column align-start justify-center">
        <p class="text-title" v-text="teacherName" />
        <v-link mode="primary" class="text-body-bold" :href="context.student.teachers[0].link" target="_blank">
          Открыть визитку
        </v-link>
      </div>
    </div>
  </v-menu-base>
</template>

<style lang="scss">
.student-teacher-menu {
  width: min(500px, 60vw);

  @media (orientation: portrait) {
    width: min(500px, 60vh);
  }

  display: flex;
  gap: 16px;

  &__avatar {
    border-radius: 999px;
  }
}
</style>
